export function nowToString() {
  const d = new Date()
  return (
    d.getFullYear().toString() +
    String(d.getMonth() + 1).padStart(2, '0') +
    String(d.getDate()).padStart(2, '0') + '_' +
    String(d.getHours()).padStart(2, '0') +
    String(d.getMinutes()).padStart(2, '0') +
    String(d.getSeconds()).padStart(2, '0')
  )
}
export function dateToString(date) {
  return (
    date.getFullYear().toString() + '-' +
    String(date.getMonth() + 1).padStart(2, '0') + '-' +
    String(date.getDate()).padStart(2, '0')
  )
}
export function datetimeToString(date) {
  return (
    date.getFullYear().toString() +
    String(date.getMonth() + 1).padStart(2, '0') +
    String(date.getDate()).padStart(2, '0') + '_' +
    String(date.getHours()).padStart(2, '0') +
    String(date.getMinutes()).padStart(2, '0') +
    String(date.getSeconds()).padStart(2, '0')
  )
}

// For API values that represent a calendar date (contract date, install date, etc.).
// `new Date('2026-10-01')` parses as UTC midnight, so reading it back with the
// local getters shifts it a day west of UTC (2026-09-30 in MT). Take the calendar
// date straight off the string instead, so it never moves with the viewer's zone.
export function apiDateToString(value) {
  if (!value) return null
  const isoDate = /^(\d{4}-\d{2}-\d{2})/.exec(value)
  if (isoDate) return isoDate[1]
  const date = new Date(value)
  return isNaN(date.getTime()) ? null : dateToString(date)
}
